/* eslint max-len: 0 */
import React from 'react';
import classnames from 'classnames';

export default class Map extends React.Component {
  render() {
    const styles = {
      wrapper: classnames({
        map: true,
        loaded: false,
      }),
      mapShadow: classnames('shadow'),
      mapShock: classnames('shock'),
      markerCe: classnames('marker', 'marker-ce'),
      markerAv: classnames('marker', 'marker-av'),
    };

    return (
      <svg className={styles.wrapper} viewBox="0 0 522 758">
        <g>
          <polygon
            fill="#202020"
            points="337,659.4 322.2,659 311.9,660.3 299.6,657 274.8,660.2 251.7,652.9 234.3,651.5 206.8,637.8
            192.8,639.5 185.9,632.7 170.3,646.6 170.8,665.4 170.7,666.7 193.9,681.3 211.3,706.8 237.4,718.9 253.9,740.9 284.2,758
            284.5,743.5 297.9,739 298.6,712.7 332.2,673.2     "
          />
          <polygon
            fill="#202020"
            points="499.3,537.3 474.5,507.2 419.7,457.4 417.9,444.9 428.8,432.9 424.7,426.3 386.1,417.5 336.6,381.6
            309.3,308.4 303.2,283.6 293.1,248.9 267.1,216.8 254.9,177 267.8,151.3 281.9,151.5 278.4,127 296.7,108.9 314.7,115.6
            328.9,106.7 349.5,108 345.3,94.7 352.5,85.1 351.9,70.4 329.4,48.3 297.2,40.6 276.2,11.3 237.3,12 222.3,23.1 207.2,21.3
            186.1,38.4 164.6,32 155,20.5 124.3,47.7 110.5,26 85.5,47.9 43.7,42.4 2,65.6 16.4,92.8 12.3,105.5 24.5,118.4 4.4,124.9
            0,140.4 11.9,149.3 10.5,171 31.9,182.3 24.9,201.1 44.2,199.4 82,175.4 120.5,186 137.6,207.8 150.7,270.6 161.9,301.8
            179.2,319.9 210,370.1 209.5,384 227.5,403.3 270.1,446.8 281.3,462.8 294.3,468.8 298.4,480.8 317,488.4 326.3,515 352.6,525.4
            366.5,596.8 366.1,616.3 354.4,624 351.3,643.2 341.3,654.3 334.2,676.8 339.1,688.4 354.6,691 361.6,679.6 388.6,650.3
            394.1,627.8 409.4,621.5 424.4,618.4 422.8,597.2 401.5,576.1 404.7,540.5 420.7,528.9 438.1,527.5 449.1,540.5 464.9,542.1
            483.3,570.7 498.8,582.3 507.4,576.6 512,564.8     "
          />
        </g>
        <g>
          <polygon
            fill="#db424c"
            points="347,649.4 332.2,649 321.9,650.3 309.6,647 284.8,650.2 261.7,642.9 244.3,641.5 216.8,627.8
            202.8,629.5 195.9,622.7 180.3,636.6 180.8,655.4 180.7,656.7 203.9,671.3 221.3,696.8 247.4,708.9 263.9,730.9 294.2,748
            294.5,733.5 307.9,729 308.6,702.7 342.2,663.2     "
          />
          <polygon
            fill="#db424c"
            points="509.3,527.3 484.5,497.2 429.7,447.4 427.9,434.9 440.8,422.9 434.7,416.3 396.1,407.5 346.6,371.6
            319.3,298.4 313.2,273.6 303.1,238.9 277.1,206.8 264.9,167 277.8,141.3 291.9,141.5 288.4,117 306.7,98.9 324.7,105.6
            338.9,96.7 359.5,98 355.3,84.7 366.5,75.1 361.9,60.4 339.4,38.3 307.2,30.6 286.2,1.3 244.3,0 232.3,13.1 213.2,9.3 196.1,28.4
            174.6,22 165,10.5 134.3,37.7 119.5,10 95.5,37.9 53.7,32.4 12,55.6 26.4,82.8 22.3,95.5 34.5,108.4 14.4,114.9 10,130.4
            21.9,139.3 20.5,161 41.9,172.3 34.9,191.1 54.2,189.4 92,165.4 130.5,176 147.6,197.8 160.7,260.6 171.9,291.8 189.2,309.9
            220,360.1 219.5,374 237.5,393.3 280.1,436.8 291.3,452.8 304.3,458.8 308.4,470.8 327,478.4 336.3,505 362.6,515.4 376.5,586.8
            376.1,606.3 364.4,614 361.3,633.2 351.3,644.3 344.2,666.8 349.1,678.4 364.6,681 371.6,669.6 402.6,642.3 404.1,617.8
            419.4,611.5 434.4,608.4 432.8,587.2 411.5,566.1 414.7,530.5 430.7,518.9 448.1,517.5 459.1,530.5 474.9,532.1 493.3,560.7
            508.8,572.3 517.4,566.6 522,554.8     "
          />
        </g>
        <g className={styles.markerCe}>
          <ellipse className={styles.mapShadow} fill="#202020" cx="324.5" cy="447.7" rx="6.5" ry="4" />
          <polygon className={styles.mapShock} fill="#ffffff" points="324.6,447.7 324.6,425.3 308,425.3 324.6,391.7 324.6,414.1 343,414.1  " />
        </g>
        <g className={styles.markerAv}>
          <ellipse className={styles.mapShadow} fill="#202020" cx="353.5" cy="465.7" rx="6.5" ry="4" />
          <polygon className={styles.mapShock} fill="#ffffff" points="353.6,465.7 353.6,443.3 337,443.3 353.6,409.7 353.6,432.1 372,432.1  " />
        </g>
      </svg>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Map.jsx
 **/